import FilterPopup from './filter-popup'

export default FilterPopup
